import styles from './WorkTypeSummary.less';

import React from 'react';

export default class WorkTypeSummary extends React.Component {

  static propTypes = {
    workTypes: React.PropTypes.array.isRequired
  };

  render() {
    const selectedWorkTypes = this.props.workTypes.filter(item => item.isActive);
    const total = this.props.workTypes.length;
    const count = selectedWorkTypes.length;

    return (
      <span className={`${styles.root} ${count === 1 ? styles.root_hasOneSelected : ''}`}>
        <span className={styles.count}>
          <span>{ count === 0 || count === total ? 'All' : count } </span>
          <span className={styles.work}>work </span>
          <span>type{ count !== 1 && 's' }</span>
        </span>

        {
          count > 0 && (
            <span>
              <span className={styles.colon}>: </span>
              {
                selectedWorkTypes.map((type, i) => {
                  return (
                    <span key={i} className={styles.workType}>
                      { i > 0 && ', ' }
                      { type.label.split('/')[0] }
                    </span>
                  );
                })
              }
            </span>
          )
        }
      </span>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/WorkTypeSummary/WorkTypeSummary.js
 **/